import { render } from "./App.vue?vue&type=template&id=6b796f8e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "F:\\200 Desarrollos\\SIE\\SIE-Publico\\SIE.Frontend\\WEB.Home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__